import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { DivContainer } from "./fields.js";

export class PersonneMoraleExtendedContainer extends DivContainer {
	static className = "PersonneMoraleExtendedContainer";
	
	static properties = {
		sigle: { type: Boolean, attribute: "sigle", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		greffe : {
			type: Boolean, attribute: "greffe", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		representative : {
			type: Boolean, attribute: "representative", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		exercises : {
			type: Boolean, attribute: "exercises", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		rcsLocation : {
			type: Boolean, attribute: "rcs-location", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		representativeName : {
			type: Boolean, attribute: "representative-name", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		representativeAddress : {
			type: Boolean, attribute: "representative-address", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		}
	};

	constructor() {
    super();
    this.sigle = true;
    this.representative = true;
	this.exercises = false;
	this.greffe = true;
	this.rcsLocation = true;
	this.representativeName = false;
	this.representativeAddress = false;
	
    this.content = () => html`
      <row-wrapper>
        <text-field label="Dénomination *" required name="denomination"></text-field>
      </row-wrapper>
      ${this.sigle
        ? html`
            <row-wrapper>
              <text-field label="Sigle (abréviation)" name="abbreviation"></text-field>
            </row-wrapper>
          `
        : ""}
      <row-wrapper>
        <select-from-api
          label="Forme juridique *"
          api-url="${window.APP_URL.api.legalForm}"
          required
          value="0"
          null-option-text="Forme Juridique"
          null-option-value="0"
		  name="id_legal_form"
		  discard-legal-form="true"
        ></select-from-api>
      </row-wrapper>
      <row-wrapper>
        <text-field label="Adresse *" required name="address"></text-field>
      </row-wrapper>
      <autocomplete-ville></autocomplete-ville>
	  ${this.rcsLocation
		? html`
			  <row-wrapper>
			    <text-field label="Lieu d'immatriculation (RCS) *" required name="registration_location"></text-field>
			  </row-wrapper>
	  ` : ""}
      <rcs-number-field label="Numéro de RCS *" required></rcs-number-field>
      ${this.representative
        ? html`
            <row-wrapper>
              <text-field label="Représentant permanent *" required name="permanent_representative"></text-field>
            </row-wrapper>
          `
        : ""}
		
	  ${this.greffe
		  ? html`
			<row-wrapper>
			<text-field label="Greffe *" required name="greffe"></text-field>
			</row-wrapper>
		    `
		  : ""}
		  
	  ${this.representativeName ? html`
	  <row-with-tooltip tooltip-text="Indiquer la civilité (M./Mme/Melle), le(s) prénom(s) et le nom.">
	  <text-field label="Nom du représentant *" required name="representantive"></text-field>
	  </row-with-tooltip>
	  ` : ""}
		  
	  ${this.exercises
	      ? html`
	  		<row-wrapper>
	  			<text-field label="Nombre d'exercices *" required name="number_of_exercises" disable-autocomplete></text-field>
	  		</row-wrapper>
	  		<row-wrapper>
	  			<date-field label="Date de fin d'exercice *" required name="date_end_exercises"></date-field>
	  		</row-wrapper>
	        `
	      : ""}
		  
	${this.representativeAddress ? html`
	<row-with-tooltip tooltip-text="Indiquer l'adresse complète, code postal et ville.">
	<text-field label="Adresse complète du représentant *" required name="representative_address"></text-field>
	</row-with-tooltip>
	` : ""}

    `;
  	}
	
	isTransient (){
		return false;
	}
}

customElements.define ("personne-morale-extended", PersonneMoraleExtendedContainer);
